import React from 'react';
// Custom module styles
import classes from '../appScreenControls.module.css';

const AppFooter = () => {
  return <div className={classes.sidebar_controls}>AppFooter</div>;
};

export default AppFooter;
